export const GET_PUSH_NOTIFICATIONS_LOG_REQUEST = "GET_PUSH_NOTIFICATIONS_LOG_REQUEST";
export const GET_PUSH_NOTIFICATIONS_LOG_SUCCESS = "GET_PUSH_NOTIFICATIONS_LOG_SUCCESS";
export const GET_PUSH_NOTIFICATIONS_LOG_FAILURE = "GET_PUSH_NOTIFICATIONS_LOG_FAILURE";
